//DO NOT TOUCH IT this is ugly
//Big *shit* of code to handle *shittiest* date picker ever (handle change event and display value if not a valid date)
export const handleDatePicker = function(selector = 'body'){
    $(document).find(selector).find('.datepicker-here').not('.time-only').each( function(){
        var startValue = $(this).val();
        if (startValue.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/g)){
            startValue = moment(startValue, 'DD/MM/YYYY').toDate();
        }
        try {
            $(this).datepicker({
                startDate: startValue,
                onSelect: function (formattedDate, date, inst) {
                    $(inst.el).change();
                }
            });
            $(this).data('datepicker').selectDate(startValue);
        } catch(error) {}
    });

    $(document).find(selector).find('.datepicker-here.time-only').each( function(){
        var startValue = $(this).val();
        if (startValue.match(/^[0-2][0-9]:[0-5][0-9]$/g)){
            startValue = new Date(Date.parse('2000-01-01 ' + startValue));
        }
        try {
            $(this).datepicker({
                startDate: startValue,
                onSelect: function (formattedDate, date, inst) {
                    $(inst.el).change();
                }
            });
            $(this).data('datepicker').selectDate(startValue);
        } catch(error) {}
    });
}


// WEBPACK FOOTER //
// ./assets/js/datepicker.js